import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { default as CheckIcon } from '@parchment/ui-icons/lib/ai/check-2';
import { Section, Button } from '@parchment/ui-primitives';
import '../style/P6LearnerLandingPage.less';

export default class P6LearnerLandingPage extends Component {

    static get propTypes() {
        return {
            learnerOrderingUri: PropTypes.string.isRequired
        };
    }

    constructor(props) {
        super(props);

        this.handleContinueClick = this.handleContinueClick.bind(this);
    }

    handleContinueClick() {
        window.location.href = this.props.learnerOrderingUri;
    }

    render() {
        return (<Section additionalClasses="default wildSand p6-learner-landing-page-container" shadow="top">
            <h3><CheckIcon/> IN NETWORK</h3>
            <p>
                This school has Parchment ordering embedded on their website.<br />
                <span className="font-weight-bold">You will be redirected
                </span> to the school's website to continue with you order.
            </p>
            <Button className="primary" block
                    size="large"
                    onSubmit={this.handleContinueClick}
                    role="link">
                CONTINUE
            </Button>
        </Section>);
    }
}
